module.exports = __webpack_public_path__ + "resources/img/item5.70b932fb.svg";